/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelClassEnum } from './ModelClassEnum';
import { ModelClassEnumFromJSON, ModelClassEnumFromJSONTyped, ModelClassEnumToJSON } from './ModelClassEnum';

/**
 *
 * @export
 * @interface PerformanceMetric
 */
export interface PerformanceMetric {
  /**
   *
   * @type {number}
   * @memberof PerformanceMetric
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerformanceMetric
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PerformanceMetric
   */
  funcName: string;
  /**
   *
   * @type {ModelClassEnum}
   * @memberof PerformanceMetric
   */
  modelClass: ModelClassEnum;
  /**
   *
   * @type {boolean}
   * @memberof PerformanceMetric
   */
  higherIsBetter: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerformanceMetric
   */
  bounded: boolean;
}

/**
 * Check if a given object implements the PerformanceMetric interface.
 */
export function instanceOfPerformanceMetric(value: object): value is PerformanceMetric {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('funcName' in value) || value['funcName'] === undefined) return false;
  if (!('modelClass' in value) || value['modelClass'] === undefined) return false;
  if (!('higherIsBetter' in value) || value['higherIsBetter'] === undefined) return false;
  if (!('bounded' in value) || value['bounded'] === undefined) return false;
  return true;
}

export function PerformanceMetricFromJSON(json: any): PerformanceMetric {
  return PerformanceMetricFromJSONTyped(json, false);
}

export function PerformanceMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformanceMetric {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    funcName: json['func_name'],
    modelClass: ModelClassEnumFromJSON(json['model_class']),
    higherIsBetter: json['higher_is_better'],
    bounded: json['bounded'],
  };
}

export function PerformanceMetricToJSON(value?: Omit<PerformanceMetric, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    func_name: value['funcName'],
    model_class: ModelClassEnumToJSON(value['modelClass']),
    higher_is_better: value['higherIsBetter'],
    bounded: value['bounded'],
  };
}
